import { Datasource, IDatasource } from 'utility-ng-kernel';
import { SchedulerStudentPlan } from '../builders/scheduler_student_plan';

export interface ISchedulerStudentPlanDatasource extends IDatasource<SchedulerStudentPlan> {}

angular.module('capability-ng-scheduler').factory(
  'ngSchedulerStudentPlanDatasource',
  (): ISchedulerStudentPlanDatasource =>
    new Datasource({
      builderType: SchedulerStudentPlan
    })
);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/search_and_add_courses/datasource/student_plans_datasource.ts